













/**
 * This abomination was implemented to satisify a requirement of the existing tablet.
 */
import { Component, Prop } from "vue-property-decorator";

import WCheckbox from "./Checkbox.vue";

// Mixins
import { FieldMixin, TextMixin, EventMixin, Event, Validator } from "./mixins";

@Component
export default class WContactCheckbox extends WCheckbox {
  @Prop({ type: String, required: true })
  optedInPath!: string;

  get optedInValue(): boolean {
    return !!this.getVariable(this.optedInPath);
  }

  get isChecked() {
    return this.fieldValue || this.optedInValue;
  }

  get computedDisabled() {
    return this.optedInValue;
  }

  changeHandler() {
    this.$nextTick(() => {
      const event = this.isChecked ? "checked" : "unchecked";
      if (event === "checked" && !this.state) {
        return;
      }
      this.broadcastEvents(event);
    });
  }
}
